import React from 'react';
import _ from 'lodash';

class NeedsImprovement extends React.Component {
  render() {
    if (this.props.data === null) {
      return (
        <div className="lowest-scores">
          <p>Loading...</p>
        </div>
      )
    } else {
      let worst = {};
      
      const lowest = this.props.data;
      _.each(lowest, function (sites, metric) {
          worst[metric] = _.slice(sites, 0, 10);
      });
      const worst_array = Object.entries(worst);

      const site_lists = worst_array.map(function(metric) {
          const chartLabel = metric[0];
          const chartIndex = metric[0];

          // Don't show progessive web app score.
          if (chartLabel === 'pwa') {
              return false;
          }

          let scoreLabel = "";
          if (chartLabel === "performance") {
              scoreLabel = "Perf";
          }
          else if (chartLabel === "best-practices") {
              scoreLabel = "BP";
          }
          else if (chartLabel === "accessibility") {
              scoreLabel = "A11y";
          }
          else if (chartLabel === "seo") {
              scoreLabel = "SEO";
          }

          const site_list = metric[1].map(function (site) {
            const link = "/#" + site.site;
            const number = parseInt(100 * parseFloat(site.average));
            return <li key={site.site}><strong><a href={link}>{site.site}</a></strong> | {number}</li>;
          });

          return <div key={chartIndex} className="list"><div className="label">{scoreLabel}</div><ul>{site_list}</ul></div>
      });

      return (
        site_lists.length > 0 ? (
          <div className="lowest-scores">
            <p>Sites that need improvement. These are the lowest performing site in each category.</p>
              <div className="lowest-scores-wrapper">
                  {site_lists}
              </div>
          </div>
        ) : null
      );
    }
  }
}

export default NeedsImprovement;